import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfirmAccountComponent } from './confirm-account/confirm-account/confirm-account.component';
import { LoginComponent } from './login/login/login.component';
import { RecoveryComponent } from './recovery/recovery/recovery.component';

const routes: Routes = [
	{ path: 'login', component: LoginComponent },
	{ path: 'recovery', component: RecoveryComponent },
	{
		path: 'confirmAccount',
		children: [
			{ path: ':token', component: ConfirmAccountComponent },
			{ path: '', redirectTo: '/login', pathMatch: 'full' }
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PublicRoutingModule {}
